<template>
    <form
        class="flex flex-wrap border border-gray-200 rounded py-3 px-4"
        @submit.prevent="saveRekeningPegawai"
    >
        <div class="lg:w-1/2 md:w-full">
            <div class="flex p-8 flex-col mb-3">
                <div class="field w-full px-3 mb-3">
                    <JetLabel
                        class="w-full"
                        for="nama_lengkap"
                        value="Nama Lengkap"
                    />

                    <InputDataGrid
                        ref="pegawaiInputDataGrid"
                        :config="pegawaiInputDataGridConfig"
                        :error="form.errors.pegawai_id"
                        :disabled="form.id"
                        @getInputDataGrid="getInputDataGridPegawai"
                    />
                    <InputError
                        :message="form.errors.pegawai_id"
                        class="mt-2"
                    />
                </div>
            </div>
            <div class="flex p-8 flex-col mb-3">
                <div class="flex flex-wrap">
                    <div class="field w-full px-3 mb-3">
                        <JetLabel
                            class="w-full"
                            for="rekening"
                            value="Rekening"
                        />
                    </div>
                    <div class="lg:w-1/8 md:w-1/4 pb-4">
                        <div class="w-full px-3 text-center">
                            <JetLabel for="is_rek_gaji" value="Gaji" />
                            <Checkbox
                                id="is_rek_gaji"
                                v-model="form.is_rek_gaji"
                                :binary="true"
                            />
                        </div>
                    </div>
                    <div class="lg:w-1/8 md:w-1/4 pb-4">
                        <div class="w-full px-3 text-center">
                            <JetLabel for="is_rek_um" value="UM" />
                            <Checkbox
                                id="is_rek_uang_makan"
                                v-model="form.is_rek_uang_makan"
                                :binary="true"
                            />
                        </div>
                    </div>
                    <div class="lg:w-1/8 md:w-1/4 pb-4">
                        <div class="w-full px-3 text-center">
                            <JetLabel for="is_rek_ikw" value="IKW" />
                            <Checkbox
                                id="is_rek_ikw"
                                v-model="form.is_rek_ikw"
                                :binary="true"
                            />
                        </div>
                    </div>
                    <div class="lg:w-1/8 md:w-1/4 pb-4">
                        <div class="w-full px-3 text-center">
                            <JetLabel for="is_rek_ikk" value="IKK" />
                            <Checkbox
                                id="is_rek_ikk"
                                v-model="form.is_rek_ikk"
                                :binary="true"
                            />
                        </div>
                    </div>
                    <div class="lg:w-1/8 md:w-1/4 pb-4">
                        <div class="w-full px-3 text-center">
                            <JetLabel for="is_rek_ipp" value="IPP" />
                            <Checkbox
                                id="is_rek_ipp"
                                v-model="form.is_rek_ipp"
                                :binary="true"
                            />
                        </div>
                    </div>
                    <div class="lg:w-1/8 md:w-1/4 pb-4">
                        <div class="w-full px-3 text-center">
                            <JetLabel for="is_rek_tutam" value="Tutam" />
                            <Checkbox
                                id="is_rek_tutam"
                                v-model="form.is_rek_tutam"
                                :binary="true"
                            />
                        </div>
                    </div>
                    <div class="lg:w-1/8 md:w-1/4 pb-4">
                        <div class="w-full px-3 text-center">
                            <JetLabel for="is_rek_itp" value="ITP" />
                            <Checkbox
                                id="is_rek_itp"
                                v-model="form.is_rek_itp"
                                :binary="true"
                            />
                        </div>
                    </div>
                    <div class="lg:w-1/8 md:w-1/4 pb-4">
                        <div class="w-full px-3 text-center">
                            <JetLabel for="is_rek_honor" value="Honor" />
                            <Checkbox
                                id="is_rek_honor"
                                v-model="form.is_rek_honor"
                                :binary="true"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="lg:w-1/2 md:w-full">
            <div class="flex p-8 flex-col mb-3">
                <div class="field w-full px-3 mb-3">
                    <JetLabel
                        class="w-full"
                        for="no_rekening"
                        value="No Rekening"
                    />
                    <Input
                        id="no_rekening"
                        v-model="form.no_rekening"
                        type="text"
                        placeholder=""
                        class="mt-1 block w-full"
                        :class="{ 'p-invalid': form.errors.no_rekening }"
                    />
                    <InputError
                        :message="form.errors.no_rekening"
                        class="mt-2"
                    />
                </div>
                <div class="field w-full px-3 mb-3">
                    <JetLabel
                        class="mt-3 w-full"
                        for="nama_rekening"
                        value="Nama Rekening"
                    />
                    <Input
                        id="nama_rekening"
                        v-model="form.nama_rekening"
                        type="text"
                        placeholder=""
                        class="mt-1 block w-full"
                        :class="{ 'p-invalid': form.errors.nama_rekening }"
                    />
                    <InputError
                        :message="form.errors.nama_rekening"
                        class="mt-2"
                    />
                </div>
                <div class="field w-full px-3 mb-3">
                    <JetLabel
                        class="mt-3 w-full"
                        for="nama_bank_opt"
                        value="Nama Bank"
                    />
                    <Select
                        id="nama_bank_opt"
                        class="mt-1 block w-full"
                        :class="{ 'p-invalid': form.errors.nama_bank }"
                        :options="$page.props.options.nama_bank_opt"
                        v-model="form.nama_bank"
                    />
                    <InputError :message="form.errors.nama_bank" class="mt-2" />
                </div>
            </div>
        </div>
        <div class="lg:w-full md:w-full">
            <div class="flex flex-col mb-6">
                <div class="w-full px-3 text-center">
                    <InertiaButtonEdit
                        :class="{ 'opacity-25': form.processing }"
                        label="Simpan Data"
                        v-if="form.id"
                    />
                    <InertiaButtonSave
                        :class="{ 'opacity-25': form.processing }"
                        label="Simpan Baru"
                        v-else
                    />
                </div>
            </div>
        </div>
    </form>
</template>
<script>
import { defineComponent } from "vue";
import Checkbox from "primevue/checkbox";
import ButtonSave from "@/Components/ButtonSave";
import JetLabel from "@/Jetstream/Label";
import Input from "@/Components/Input.vue";
import InputError from "@/Components/InputError.vue";
import InertiaButtonSave from "@/Components/InertiaButtonSave.vue";
import InertiaButtonEdit from "@/Components/InertiaButtonEdit.vue";
import Select from "@/Components/Select";

import InputDataGrid from "@/Components/InputDataGrid";

const totalRowShowed = 5;

export default defineComponent({
    props: ["selectedData"],
    components: {
        Checkbox,
        ButtonSave,
        JetLabel,
        Input,
        InputError,
        InertiaButtonSave,
        InertiaButtonEdit,
        Select,
        InputDataGrid,
    },
    data() {
        return {
            pegawaiInputDataGridConfig: {
                table: "pegawai",
                formName: "nama_lengkap",
                defineCols: [
                    {
                        field: "nip",
                        header: "NIP",
                        style: "max-width: 15rem",
                    },
                    {
                        field: "nama_lengkap",
                        header: "Nama",
                        style: "max-width: 25rem",
                    },
                ],
                dtSourceApiRoute: {
                    list: "pegawai.data",
                },
            },
            form: this.$inertia.form({
                _method: "POST",
                id: null,
                pegawai_id: null,
                nama_lengkap: null,
                no_rekening: null,
                nama_rekening: null,
                nama_bank: this.$page.props.options.nama_bank_opt[0],
                is_rek_gaji: false,
                is_rek_uang_makan: false,
                is_rek_ikw: false,
                is_rek_ikk: false,
                is_rek_ipp: false,
                is_rek_tutam: false,
                is_rek_itp: false,
                is_rek_honor: false,
            }),
        };
    },
    mounted() {
        //
    },
    watch: {
        // whenever question changes, this function will run
        selectedData(newSelectedData, oldSelectedData) {
            this.resetForm();
        },
    },
    methods: {
        addItem: function () {
            //
        },
        getInputDataGridPegawai: function (inputData) {
            this.form.pegawai_id = inputData.id;
        },
        populateEdit: function (rekeningpegawai) {
            // console.log(rekeningpegawai);
            this.form.id = rekeningpegawai.id;
            this.form.pegawai_id = rekeningpegawai.pegawai_id;
            this.form.nama_lengkap = rekeningpegawai.pegawai.nama_lengkap;
            this.form.no_rekening = rekeningpegawai.no_rekening;
            this.form.nama_rekening = rekeningpegawai.nama_rekening;
            this.form.nama_bank = rekeningpegawai.nama_bank;
            this.form.is_rek_gaji = rekeningpegawai.is_rek_gaji ? true : false;
            this.form.is_rek_uang_makan = rekeningpegawai.is_rek_uang_makan
                ? true
                : false;
            this.form.is_rek_ikw = rekeningpegawai.is_rek_ikw ? true : false;
            this.form.is_rek_ikk = rekeningpegawai.is_rek_ikk ? true : false;
            this.form.is_rek_ipp = rekeningpegawai.is_rek_ipp ? true : false;
            this.form.is_rek_tutam = rekeningpegawai.is_rek_tutam
                ? true
                : false;
            this.form.is_rek_itp = rekeningpegawai.is_rek_itp ? true : false;
            this.form.is_rek_honor = rekeningpegawai.is_rek_honor
                ? true
                : false;
            this.$refs.pegawaiInputDataGrid.setData(rekeningpegawai);
        },
        resetForm: function (event) {
            this.form.id = null;
            this.form.pegawai_id = null;
            this.form.nama_lengkap = null;
            this.form.no_rekening = null;
            this.form.nama_rekening = null;
            this.form.nama_bank = this.$page.props.options.nama_bank_opt[0];
            this.form.is_rek_gaji = false;
            this.form.is_rek_uang_makan = false;
            this.form.is_rek_ikw = false;
            this.form.is_rek_ikk = false;
            this.form.is_rek_ipp = false;
            this.form.is_rek_tutam = false;
            this.form.is_rek_itp = false;
            this.form.is_rek_honor = false;
            // this.form.reset();
            this.$refs.pegawaiInputDataGrid.clear();
            this.form.clearErrors();
        },
        saveRekeningPegawai: function (event) {
            let self = this;
            this.form.post(route("rekeningpegawai.store"), {
                errorBag: "saveRekeningPegawai",
                preserveScroll: true,
                onSuccess: () => {
                    if (self.form.id) {
                        self.$emit("changeData", self.form);
                    } else {
                        self.$emit("loadData");
                        // self.$emit('addData', self.form);
                        self.resetForm();
                    }
                },
                onFinish: () => {
                    //
                },
            });
        },
    },
});
</script>